import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { CustomSwitch } from "components/common/Switch";
import { usePermissions } from "layouts/Admin";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";

import {
  fetchHolidayRates,
  holidayRatesSelector,
  removeMultipleHolidayRates,
  changeHolidayRateStatus
} from "slices/holidayRateSlice";

import AddHolidayRate from "components/holiday/AddHolidayRateForm";
import { convertTimeToUTCFormatted } from "helpers/convertTimeToUTC";

function HolidayRatesList() {
  const dispatch = useDispatch();
  const { checkPermission } = usePermissions();

  const {
    holidayRates,
    last_page: totalPages,
    loader,
    total,
    current_page,
    per_page: pageLength,
  } = useSelector(holidayRatesSelector);

  const [addForm, setAddForm] = React.useState({ show: false, item: {} });
  const refAddButton = React.useRef(null);
  
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  console.log(deleteModal , 'asasasasasasas')
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: "holiday_name",
    sortDirection: "asc",
  });

  React.useEffect(() => {
    dispatch(fetchHolidayRates());
  }, []);

  const handleAddPopUp = (item) => {
    setAddForm({ show: true, item });
  };

  const submitCallback = (status, message) => {
    console.log(status, 'statussss')
    if (status) {
      toast.success(message, { className: "successToast" });
      setSelectedItems([]);
      setSelectAll(false);
      dispatch(fetchHolidayRates());
      hideConfirmDialog();
    } else {
      toast.error(message, { className: "errorToast" });
    }
  };

  const showConfirmDialog = () => setDeleteModal(true);
  const hideConfirmDialog = () => setDeleteModal(false);

  const handleRemoveItems = () => {
    dispatch(removeMultipleHolidayRates({ ids: selectedItems }, submitCallback));
    setDeleteModal(false)
  };

  const handleChange = (e) => {
    const id = e.target.dataset.value;
    setSelectedItems(
      selectedItems.includes(id)
        ? selectedItems.filter((item) => item !== id)
        : [...selectedItems, id]
    );
  };

  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
      setSelectAll(false);
      return;
    }
    setSelectAll(true);
    setSelectedItems(holidayRates?.map((rate) => rate.id.toString()));
  };

  const handlePageChange = React.useCallback((page) => {
    dispatch(fetchHolidayRates(page));
  }, []);

 const handleClose = () => {
  setAddForm({ show: false, item: {} });
};

  //#region TABLE HEAD
  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir });
      dispatch(fetchHolidayRates(current_page, { sortBy, sortDirection: dir, search: searchTerm }));
    };

    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
            {checkPermission("Delete Holiday Rates") && (
              <label className="custom-checkbox checkbox">
                <input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} />
                <span className="checkmark"></span>
              </label>
            )}
          </div>
        </th>
        <th className="col">
          <TableHeaderItem title="Holiday Name" sortBy="holiday_name" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        <th className="col">Start Date</th>
        <th className="col">End Date</th>
        <th className="col">Holiday Rate</th>
        <th className="col">
          <TableHeaderItem title="Created At" sortBy="created_at" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        {checkPermission("Status Holiday Rates") && <th className="col">Status</th>}
        {checkPermission("Edit Holiday Rates") && <th className="col">Actions</th>}
      </tr>
    );
  }, [selectAll, searchTerm, sortConfig, current_page, selectedItems]);
  //#endregion

  //#region TABLE BODY
  const renderTableContent = React.useCallback(() => {
    return holidayRates?.map((rate, index) => (
      <HolidayRateItem
        key={rate.id}
        rate={rate}
        index={index}
        selectedItems={selectedItems}
        handleChange={handleChange}
        handleAddPopUp={handleAddPopUp}
        current_page={current_page}
        pageLength={pageLength}
        checkPermission={checkPermission}
      />
    ));
  }, [holidayRates, selectedItems]);
  //#endregion

  return (
    <ListLayout
      heading="Holiday Rates"
      title=""
      buttonTitle="Add Holiday Rate"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      addButtonDisabled={!checkPermission("Create Holiday Rates")}
      fetchList={fetchHolidayRates}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => (
        <AddHolidayRate item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} statusPerm={checkPermission("Status Holiday Rates")} />
      )}
      refAddButton={refAddButton}
      refAddPopUp="#holidayRateModal"
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddPopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      disableBootstrap={true}
      noOfItems={total}
      searchPlaceholder="Search Holiday Rates..."
    >
      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  );
}
const HolidayRateItem = ({
  rate,
  index,
  selectedItems,
  handleChange,
  handleAddPopUp,
  current_page,
  pageLength,
  checkPermission,
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(rate?.status === 1 ? 1 : 0);

  React.useEffect(() => {
    setStatus(rate?.status === 1 ? 1 : 0);
  }, [rate]);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0);
    dispatch(changeHolidayRateStatus(id, { status: s ? 1 : 0 }));
  };

  const getBackgroundStyle = (status) => (status === 0 ? { background: "#f4f4f4" } : {});

  const serial = useMemo(() => index + 1 + (current_page - 1) * pageLength, [current_page, pageLength]);
  console.log(rate , 'rateeee')
  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission("Delete Holiday Rates") && (
            <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="select-all"
                data-value={rate.id}
                checked={selectedItems.includes(rate.id.toString())}
                onChange={handleChange}
              />
              <span className="checkmark"></span>
            </label>
          )}
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>{rate.holiday_name}</td>
      <td style={getBackgroundStyle(status)}>{rate.start_date}</td>
      <td style={getBackgroundStyle(status)}>{rate.end_date}</td>
      <td style={getBackgroundStyle(status)}>{rate.holiday_rate}</td>
      <td style={getBackgroundStyle(status)}>{convertTimeToUTCFormatted(rate.created_at)}</td>
      {checkPermission("Status Holiday Rates") && (
        <td style={getBackgroundStyle(status)}>
          <div className="row_check">
            <CustomSwitch handleChange={(s) => handleStatusChange(rate.id, s)} checked={rate?.status} />
          </div>
        </td>
      )}
      {checkPermission("Edit Holiday Rates") && (
        <td style={getBackgroundStyle(status)}>
          <div className="row_check">
            <button className="table_edit" onClick={() => handleAddPopUp({ ...rate, status })}>
              Edit
            </button>
          </div>
        </td>
      )}
    </tr>
  );
};

export default HolidayRatesList;
